<app-cost-benchmark-filters *ngIf="years"
                            [years]="years"
                            [collectionStreams]="collectionStreams"
                            [type]="chartType"
                            (search)="searchData($event)"
></app-cost-benchmark-filters>
<mat-divider></mat-divider>
<app-cost-benchmark-chart *ngIf="data && chartType"
                          [title]="text"
                          [subtitle]="subtitle"
                          [data]="data.chartData"
                          [lastModifiedDate]="data.lastModifiedDate"
                          [weeeSystem]="data.weeeSystemName"
                          [type]="chartType"
>
</app-cost-benchmark-chart>
